export const isRelatedArticle = (article, relatedSlugs) => {
  const { primaryTopics } = article
  return primaryTopics?.some(({ slug }) => relatedSlugs?.includes(slug))
}
